import React from 'react';
import MainLayout from '../_layouts/main';

export default function DashboardPage() {
  return (
    <MainLayout title={'Dashboard'}>
            <h1>Bem vindo à Mobilizei!</h1>
    </MainLayout>
  );
}